import { useState } from "react";
import { FaPlusSquare } from "react-icons/fa";
import Enums from "@/enums";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { RiListCheck3 } from "react-icons/ri";
import Helpers from '../../Helpers';
import { FaExclamationCircle } from "react-icons/fa";
import ToolTip from "../ToolTip";
import EditSiteModal from "../modals/EditSiteModal";
import RightTimeApi from "@/API";

export default function SiteListTable(props: any) {
  const { siteData, activeSite, updateActiveSite,updateData,adminPerms, company } = props;
  const [showInactive, setShowInactive] = useState(false);
  const canEdit = adminPerms?.includes(Enums.ROLE_PERMS.EditSite)
    || adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  const canCreateSite = adminPerms?.includes(Enums.ROLE_PERMS.CreateSite)
    || adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  const [editSiteId, updateEditSiteId] = useState(null);
  const apiUrl = Helpers.Env("VITE_API_URL");

  if (!siteData) return null;

  function onEdit(e) {
    if (!e || !e.currentTarget || typeof e.currentTarget.getAttribute !== 'function') {
      console.warn('onEdit: event or currentTarget is invalid', e);
      return;
    }
    const siteId = parseInt(e.currentTarget.getAttribute('data-id'));
    if (!siteId) {
      if (!canCreateSite) return;
      updateEditSiteId(0);
    } else {
      if (!canEdit) return;
      updateEditSiteId(siteId);
    }
  }

  async function updateActiveSiteAsync(siteId) {
    const site = siteData.sites.find(s => s.id === siteId);
    if (site) {
      props.updateActiveSite(site);
    }
  }

  function onModalClose() {
    updateEditSiteId(null);
    updateActiveSiteAsync(editSiteId);  // Reselect the site after cancel
    props.updateData();
  }

  async function toggleSiteActiveAsync(e, siteId) {
    e.stopPropagation();
    if (!canEdit || !siteId) return;
    const resp = await RightTimeApi.putAsync(`/Site/${siteId}/ToggleActive`);
    if (resp && resp.ok) {
      props.updateData();
    }
  }

  function renderStaticSite(site) {
    const isActive = site.id === props?.activeSite?.id;
    return (
      <tr
        key={"sites" + site.id}
        className={isActive ? "active" : ""}
        data-id={site.id}
        onClick={() => {
          if (isActive) {
            if (canEdit) {
              updateEditSiteId(site.id);
            }
          } else {
            updateActiveSiteAsync(site.id);
          }
        }}
      >
        <td>{site.id}</td>
        <td className="SiteLogo">
          {site && site.hasImage && site.imageId ? (
            <img src={apiUrl + "/Image/" + site.imageId} alt="" />
          ) : null}
        </td>
        <td>{site.name}

          {siteData?.permissions?.some(
            (p) => p === Enums.ROLE_PERMS.SystemAdmin
          ) && site.messages && site.messages.length > 0 && (
              <ToolTip text={site.messages.join("\n")}>
                <FaExclamationCircle className="exclamationIcon" />
              </ToolTip>
            )}
        </td>
        <td>{site.alias}</td>
        <td>
          {site.active ? (
            <MdCheckBox
              className={`actionIcon${canEdit ? "" : " disabled"}`}
              onClick={(e) => toggleSiteActiveAsync(e, site.id)}
              style={{ cursor: canEdit ? "pointer" : "default" }}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              className={`actionIcon${canEdit ? "" : " disabled"}`}
              onClick={(e) => toggleSiteActiveAsync(e, site.id)}
              style={{ cursor: canEdit ? "pointer" : "default" }}
            />
          )}
        </td>
      </tr>
    );
  }

  return (
    <div className="tableWrapper dimensionTable horizontal scrollable sitesTable">
      <table>
        <caption>
          <span className="title">{Helpers.pluralize(company.subEntityTypeName || "Site")}
          </span><span className="captionRight">
            <span
              className={`captionRight floatRight${canCreateSite ? "" : " disabled"}`}
              title={canCreateSite ? `Add ${company.subEntityTypeName}` : `You don't have permission to create ${company.subEntityTypeName.toLowerCase()}`}
              onClick={(e) => {
                if (canCreateSite) onEdit(e);
              }}
            >
              <FaPlusSquare className="actionIcon plusIcon" />
            </span>
          </span>
        </caption>
        <thead>
          <tr>
            <th>Id</th>
            <th>Logo</th>
            <th>Name</th>
            <th>Alias</th>
            <th
              className="clickable toggleColumnHeader"
              data-help-id="toggleActive"
              onClick={() => setShowInactive(!showInactive)}
            >
              <span className="toggleHeaderLabel">Active</span>
              <span className="toggleHeaderIcon" aria-hidden="true">
                <RiListCheck3 />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {props && siteData?.sites
            ? siteData.sites
              .filter(s => showInactive || s.active)
              .map((site) => {
              return renderStaticSite(site);
            })
            : null}
        </tbody>
      </table>

      {editSiteId !== null && (
        <EditSiteModal
          isOpen={editSiteId !== null}
          onClose={onModalClose}
          siteId={editSiteId}
          updateSpinner={props.updateSpinner}
          jobs={siteData.jobs}
          company={props.company}
          adminPerms={adminPerms}
        />
      )}
    </div>
  );
}
